// src/store/companySlice.js
import { createSlice } from "@reduxjs/toolkit";

const companySlice = createSlice({
  name: "company",
  initialState: {
    selectedCompany: null,
    companies: [],
  },
  reducers: {
    selectCompany: (state, action) => {
      state.selectedCompany = action.payload;
    },
    addCompany: (state, action) => {
      state.companies.push(action.payload);
    },
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
  },
});

export const { selectCompany, addCompany, setCompanies } = companySlice.actions;
export default companySlice.reducer;
